import styled from "@emotion/styled";
import { theme } from "Styles";

export const Container = styled.div`
    display: grid;
    grid-template-columns: 35px 1fr;
    grid-template-areas:
        "reference main"
        "reference main";
    grid-template-rows: 1fr;
    background-color: ${theme.palette.common.lightGrey};
    border: 1px solid ${theme.palette.tableHeader.main};
`;

export const Reference = styled.div`
    grid-area: reference;
    background-color: ${theme.palette.common.lightGrey};
    display: flex;
    justify-content: center;
    border-right: 1px solid ${theme.palette.tableHeader.main};
    padding-top: 15px;
`;

export const ReferenceInnerContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    align-items: center;
    writing-mode: vertical-lr;
    text-orientation: upright;
    label {
        text-align: center;
    }
`;

export const Main = styled.div`
    grid-area: main;
    padding: 10px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`;

export const Content = styled.div`
    padding: 10px 10px 20px 10px;
    border: 1px solid ${theme.palette.tableHeader.main};
    background-color: ${theme.palette.common.white};
`;

export const FormField = styled.div`
    .placeholder {
        font: italic normal normal 12px/16px Open Sans;
        letter-spacing: 0px;
        color: #000000;
    }
`;

export const ErrorContainer = styled.div`
    position: absolute;
    right: -25px;
    top: 0;
`;
